import React from "react";
import { Box, Typography, alpha } from "@mui/material";
import { COLORS } from "../../styles/uiConstants";

const VARIANT_STYLES = {
  default: {
    dot: COLORS.slate400,
    captionColor: COLORS.slate500,
    valueColor: COLORS.slate800,
    bg: COLORS.white,
    border: COLORS.slate200,
  },
  success: {
    dot: "#10b981",
    captionColor: "#059669",
    valueColor: "#047857",
    bg: alpha("#10b981", 0.06),
    border: alpha("#10b981", 0.2),
  },
  warning: {
    dot: "#f59e0b",
    captionColor: "#b45309",
    valueColor: COLORS.warningDarker,
    bg: alpha("#f59e0b", 0.06),
    border: alpha("#f59e0b", 0.22),
  },
  info: {
    dot: "#3b82f6",
    captionColor: "#1d4ed8",
    valueColor: "#1e3a8a",
    bg: alpha("#3b82f6", 0.06),
    border: alpha("#3b82f6", 0.22),
  },
  muted: {
    dot: COLORS.slate400,
    captionColor: COLORS.slate500,
    valueColor: COLORS.slate600,
    bg: alpha(COLORS.slate200, 0.4),
    border: COLORS.slate200,
  },
};

/**
 * Modern compact istatistik pili (atom).
 * @param {string} label - Küçük etiket
 * @param {string|number} value - Sayı veya metin
 * @param {"default"|"success"|"warning"|"info"|"muted"} variant
 */
export default function StatCard({ label, value, variant = "default" }) {
  const styles = VARIANT_STYLES[variant] || VARIANT_STYLES.default;
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        gap: 1.25,
        px: 1.75,
        py: 0.85,
        borderRadius: 2.5,
        border: `1px solid ${styles.border}`,
        bgcolor: styles.bg,
        minWidth: 90,
        transition: "transform 0.18s ease, box-shadow 0.18s ease",
        "&:hover": {
          transform: "translateY(-1px)",
          boxShadow: `0 4px 10px ${alpha(styles.dot, 0.15)}`,
        },
      }}
    >
      <Box
        sx={{
          width: 6, height: 6, borderRadius: "50%",
          bgcolor: styles.dot,
          flexShrink: 0,
          boxShadow: `0 0 0 3px ${alpha(styles.dot, 0.18)}`,
        }}
      />
      <Box>
        <Typography
          variant="caption"
          sx={{
            color: styles.captionColor,
            fontWeight: 700,
            fontSize: "0.65rem",
            letterSpacing: "0.04em",
            textTransform: "uppercase",
            lineHeight: 1,
            display: "block",
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{
            fontWeight: 800,
            color: styles.valueColor,
            fontSize: "1.05rem",
            lineHeight: 1.2,
            mt: 0.15,
          }}
        >
          {value}
        </Typography>
      </Box>
    </Box>
  );
}
